// import axios from 'axios';
import { auth, functions } from "@/vendor/firebase";
import * as config from "@/config";
const axios = require('axios')

const BASIC_URL = config.BASIC_URL + "app/";

export function httpGet(path, data = null) {
  return new Promise(resolve => {
    auth.currentUser.getIdToken(true).then(idToken => {
      const params = { idToken, data }
      axios
        .get(BASIC_URL + path, {
          params
        })
        .then(response => {
          resolve(response.data)
        })
    })
  })
}

export function httpPost(path, data = null) {
  return new Promise(resolve => {
    auth.currentUser.getIdToken(true).then(idToken => {
      axios
        .post(BASIC_URL + path, {
          idToken, data
        })
        .then(response => {
          resolve(response.data)
        })
    })
  })
}

export function httpGetFirebaseOnCall(path, data) {
  return new Promise(resolve => {
    const callFunction = functions.httpsCallable(path);
    callFunction(data).then((response) => {
      resolve(response.data)
    });
  })
}

export function httpGetNoToken(path, data = null) {
  return new Promise(resolve => {
    const params = { data }
    axios
      .get(BASIC_URL + path, {
        params
      })
      .then(response => {
        resolve(response.data)
      })
  })
}